import { useContext } from 'react';
import TextsContext from '../TextsContext';

const useTextsContext = () => useContext(TextsContext)

export default useTextsContext
